(function () {
  if (window.__bramhallFreeShippingWatcherInitialized) return;
  window.__bramhallFreeShippingWatcherInitialized = true;

  var STORAGE_KEY = 'bramhallShippingProgress';
  var CONFETTI_COLORS = ['#3c8c5c', '#111111', '#ffffff', '#8fd6a8', '#2f6e47'];
  var CONFETTI_COUNT = 26;

  function getFillValue(bar) {
    var fill = bar.querySelector('.cart-drawer__shipping-progress-fill');
    if (!fill) return null;
    var value = parseFloat(fill.style.width);
    return isNaN(value) ? null : value;
  }

  function launchConfetti(bar) {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var burst = document.createElement('div');
    burst.className = 'cart-drawer__confetti-burst';
    burst.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < CONFETTI_COUNT; i++) {
      var piece = document.createElement('span');
      piece.className = 'cart-drawer__confetti-piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.setProperty('--confetti-color', CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)]);
      piece.style.setProperty('--confetti-delay', (Math.random() * 0.15).toFixed(2) + 's');
      piece.style.setProperty('--confetti-duration', (0.9 + Math.random() * 0.6).toFixed(2) + 's');
      piece.style.setProperty('--confetti-rotate', Math.round(Math.random() * 360) + 'deg');
      burst.appendChild(piece);
    }

    bar.appendChild(burst);
    window.setTimeout(function () {
      burst.remove();
    }, 1800);
  }

  function handleBar(bar) {
    var value = getFillValue(bar);
    if (value === null) return;

    var previous = null;
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      previous = stored === null ? null : parseFloat(stored);
    } catch (e) {
      previous = null;
    }

    if (previous !== null && previous < 100 && value >= 100) {
      launchConfetti(bar);
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (e) {
      /* sessionStorage unavailable — celebration simply won't persist across renders */
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('.cart-drawer__shipping-bar').forEach(handleBar);
  }

  function init() {
    var cartDrawer = document.getElementById('CartDrawer') || document.body;
    scan(document);

    var observer = new MutationObserver(function () {
      scan(document);
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
